<template>
  <div class="main">
    <div class="content">
      <VueCropper
        ref="cropper"
        :autoCrop="true"
        :img="imgSrc"
        alt="上传的图片"
        :fixed="true"
        :fixed-number="[1, 1]"
      >
      </VueCropper>
    </div>
    <van-uploader :after-read="afterRead">
      <button class="btn">选择图片</button>
    </van-uploader>

    <button class="btn btn2" @click="save">保存头像</button>
  </div>
</template>
<script>
import { VueCropper } from "vue-cropper";
import { uploadAttachment } from "@/api/user";
export default {
  data() {
    return {
      userInfo: null,
      imgSrc: "",
      previews: {},
      previewStyle1: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    save() {
      this.$refs.cropper.getCropBlob((data) => {
        console.log(data);
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = () => {
          console.log("文件流", reader.result);
          uploadAttachment({
            source: reader.result,
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success("上传成功");
              this.$emit("getUerInfo");
            }
          });
        };
      });
    },
    afterRead(file) {
      // console.log('file',file)
      this.imgSrc = file.content;
    },
  },
  components: { VueCropper },
  async created() {},
  mounted() {
    // this.onCropperReady()
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  background-color: #f8f8fa;
  position: relative;
  box-sizing: border-box;

  .content {
    width: 100%;
    height: 300px;
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
  }

  .btn {
    border: none;
    padding: 0;
    width: calc(100% - 30px);
    height: 46px;
    background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
    border-radius: 23px;
    color: #ffffff;
    font-size: 18px;
    margin-top: 15px;
    margin-left: 15px;
  }

  .btn2 {
    margin-bottom: 40px;
  }
}
</style>
<style scoped>
.van-uploader {
  width: 100%;
}

.van-uploader >>> .van-uploader__input-wrapper {
  width: 100%;
}
</style>
